module.exports = __webpack_public_path__ + "static/media/tier-1.9b0aeb83.jpg";